import { Accordion, AccordionDetails, AccordionSummary, Alert, Box, Button, Container, MenuItem, Snackbar, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Header from '../Components/Header'
import bgImage from "../Images/Featureshero1.jfif";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Footer from '../Components/Footer';
import Upbutton from '../upbutton/Upbutton';
import Aos from "aos";
import "aos/dist/aos.css";
import Loader from '../Loader/Loader';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const faqData = [
    {
        question: "1. How do I make a call using the dialer?",
        answer:
            "Open the dialer screen, enter the number using the keypad, and press the call button (usually a green phone icon).",
    },
    {
        question: "2. Can I view my recent calls?",
        answer:
            "Yes, tap the 'Recents' or 'Call History' tab to view your incoming, outgoing, and missed calls.",
    },
    {
        question: "3. How do I add a new contact?",
        answer:
            "Go to the Contacts tab, tap the '+' icon or 'Add Contact', and fill in the name, phone number, and any other details.",
    },
    {
        question: "4. Can I assign a custom ringtone to a contact?",
        answer:
            "Yes! Edit the contact, then select 'Set Ringtone' or 'Custom Ringtone' to choose a different sound for that contact.",
    },
    {
        question: "5. How do I block a number from calling me?",
        answer:
            "Open call history, tap on the number, then choose 'Block' or 'Add to Block List'. You can also manage blocked numbers in Settings.",
    },
    {
        question: "6. How can I import contacts from my SIM card?",
        answer:
            "Go to Contacts > Settings > Import/Export > Import from SIM. Follow the on-screen instructions to copy them.",
    },
    {
        question: "7. Why are some contacts missing?",
        answer:
            "Check if you're filtering by account (Google, SIM, etc.). Make sure sync is enabled in your device settings.",
    },
    {
        question: "8. How do I use speed dial?",
        answer:
            "Press and hold a number key (like 2 or 3) on the dialer after assigning a contact to that number in the Speed Dial settings.",
    },
    {
        question: "9. How do I back up my contacts?",
        answer:
            "Sync them with your Google account or export them via Contacts > Settings > Export to .vcf file.",
    },
    {
        question: "10. Can I restore deleted contacts?",
        answer:
            "If synced with Google, go to contacts.google.com > Settings > Undo changes. You can restore contacts deleted within the last 30 days.",
    },
    {
        question: "11. How do I edit or delete a contact?",
        answer:
            "Open the contact, tap the Edit icon (usually a pencil), make your changes or tap Delete to remove the contact.",
    },
    {
        question: "12. Why can't I hear the person on the other end?",
        answer:
            "Check your volume settings, ensure your speaker isn't blocked, or try restarting your device. You can also test with headphones.",
    },
];
const issueOptions = [
    "App Not Working",
    "Payment Issue",
    "Feature Request",
    "Can't Unlock Apps",
    "Forgot Password / PIN",
    "Fingerprint Not Working",
    "App Keeps Crashing",
    "App Lock Disabled Automatically",
    "App Consumes Too Much Battery",
    "Not Hiding Photos/Videos",
    "Intruder Selfie Not Working",
    "Notifications Not Hidden",
    "Ads Too Frequent",
    "App Slows Down Device",
    "Can't Change Lock Type",
    "Problems After Update",
    "Language / Translation Issue",
    "Request New Feature",
    "Report a Bug",
    "Need Help with Setup",
    "Can't Uninstall App",
    "Other",
];

const HelpCenter = () => {
    const [email, setEmail] = useState("");
    const [issueType, setIssueType] = useState("");
    const [message, setMessage] = useState("");
    const [messages, setMessages] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [loading, setLoading] = useState(true);
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success'
    });


    useEffect(() => {
        Aos.init({
            duration: 1000,
            easing: "ease-in-out",
            once: true,
        });
        const timer = setTimeout(() => {
            setLoading(false);
        }, 3000);
        return () => clearTimeout(timer);
    }, []);


    const handleSubmit = (e) => {
        e.preventDefault();
        setMessages([...messages, { email, issueType, message }]);
        setEmail("");
        setIssueType("");
        setMessage("");
        console.log("=====> user massages", messages);
        setSnackbar({
            open: true,
            message: 'Your message has been sent',
            severity: 'success'
        });
    };


    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') return;
        setSnackbar(prev => ({ ...prev, open: false }));
    };


    if (loading) {
        return (
            <div className="App">
                <Loader />
            </div>
        );
    }


    return (
        <Box>
            <Helmet>
                <title>Help - iCall Phone Dialer & Contacts</title>
            </Helmet>
            {/* ==== header === */}
            <Box>
                <Header />
            </Box>
            <Box sx={{ height: { xs: '56px', sm: '70px' } }} />
            {/* ===== hero sections ===== */}
            <Box sx={{
                backgroundImage: `url(${bgImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                // minHeight: '100vh',
                height: { md: '400px', xs: "300px" },
                display: 'flex',
                alignItems: 'center',
            }}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Container maxWidth="xl">
                        <Box>
                            <Typography
                                variant="h4"
                                sx={{
                                    color: '#fff',
                                    textAlign: 'center',
                                    fontWeight: 700,
                                    fontSize: { md: '34px', sm: '30px', xs: '24px' }
                                }}
                            >
                                Support & FAQs
                            </Typography>
                            <Typography variant='h6' sx={{ textAlign: 'center', color: '#fff', marginTop: '10px' }}>
                                <Link to={"/"} style={{ textDecoration: 'none', color: '#fff' }}> Home /</Link>  <span style={{ fontWeight: '700', color: "rgb(64, 153, 247)" }}> Help</span>
                            </Typography>
                        </Box>
                    </Container>
                </Box>
            </Box>
            {/* ======== help center content ======== */}
            <Box data-aos="fade-up" sx={{ paddingTop: { md: '100px', sm: '60px', xs: '30px' }, }}>
                <Container maxWidth="xl"> 
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{
                            fontSize: { md: '42px', sm: '30px', xs: '24px' }
                        }}
                    >
                        How Can We Help?
                    </Typography>
                    <Box sx={{ marginTop: { md: '50px', xs: '30px' } }}>
                        {faqData.map((faq, index) => (
                            <Accordion
                                key={index}
                                expanded={expanded === index}
                                onChange={handleChange(index)}
                                sx={{
                                    mb: 1,
                                    bgcolor: "#fff",
                                    boxShadow: 2,
                                    borderRadius: "8px",
                                    transition: "all 0.3s ease",
                                    padding: "10px",
                                    "&:hover": {
                                        backgroundColor: "rgb(64, 153, 247)",
                                        cursor: "pointer",
                                        "& .MuiTypography-root": {
                                            color: "#fff",
                                        },
                                    },
                                }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: expanded === index ? "#fff" : "#000" }} />}>
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            color: '#212121d4',
                                            fontSize: { md: "18px", xs: "16px" },
                                            transition: "color 0.3s ease",
                                        }}
                                    >
                                        {faq.question}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography
                                        sx={{
                                            color: "#757575",
                                            fontSize: "15px",
                                            lineHeight: 1.6,
                                        }}
                                    >
                                        {faq.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </Container>
            </Box>
            {/* ===== contect and help ==== */}
            <Box data-aos="fade-up" sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Container maxWidth="xl">
                    <Typography className='mainheading'
                        variant="h4"
                        sx={{
                            fontSize: { md: '42px', sm: '30px', xs: '24px' },
                            mb: 4
                        }}
                    >
                        Contact Support
                    </Typography>

                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{ marginTop: { md: '40px', xs: '30px' } }}
                    >
                        <TextField
                            label="Your Email"
                            type="email"
                            fullWidth
                            required
                            margin="normal"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        <TextField
                            label="Issue Type"
                            select
                            fullWidth
                            required
                            margin="normal"
                            value={issueType}
                            onChange={(e) => setIssueType(e.target.value)}
                        >
                            {issueOptions.map((option, i) => (
                                <MenuItem key={i} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            label="Describe Your Issue"
                            multiline
                            rows={4}
                            fullWidth
                            required
                            margin="normal"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />
                        <Button
                            variant="contained"
                            type="submit"
                            sx={{
                                mt: 2,
                                backgroundColor: 'rgb(64, 153, 247)',
                                '&:hover': {
                                    backgroundColor: '#000'
                                }
                            }}
                        // fullWidth
                        >
                            Send
                        </Button>
                    </Box>
                    {/* {messages.length > 0 && (
                        <>
                            <Typography variant="h6" sx={{ mt: 4 }}>
                                Submitted Messages:
                            </Typography>
                            <List>
                                {messages.map((msg, i) => (
                                    <ListItem key={i}>
                                        <strong>{msg.email}</strong>: {msg.issueType} — {msg.message}
                                    </ListItem>
                                ))}
                            </List>
                        </>
                    )} */}
                </Container>
            </Box>
            {/* ========= snackbar ================ */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    sx={{
                        width: '100%',
                        padding: 2,
                        backgroundColor: (theme) =>
                            theme.palette[snackbar.severity]
                                ? theme.palette[snackbar.severity].main
                                : theme.palette.primary.main,
                        color: (theme) =>
                            theme.palette[snackbar.severity]
                                ? theme.palette[snackbar.severity].contrastText
                                : theme.palette.primary.contrastText
                    }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
            {/* ======== footer ===== */}
            <Box sx={{ marginTop: { md: '100px', sm: '60px', xs: '30px' } }}>
                <Footer />
            </Box>
            {/* ====== up button ===== */}
            <Box>
                <Upbutton />
            </Box>
        </Box>
    )
}
export default HelpCenter;